(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    // Hover autoplay for product card galleries
  // Note: slideshow.js disables nested slideshows, so we re-enable them on hover
  (function () {
    const AUTOPLAY_INTERVAL = 800;
    const galleryIntervals = new WeakMap();
    const originalDisabled = new WeakMap();

    function startAutoplay(gallery) {
      if (galleryIntervals.has(gallery)) return;

      const slideshow = gallery.querySelector('slideshow-component');
      if (!slideshow || typeof slideshow.next !== 'function') return;

      // Store original disabled state and re-enable for autoplay
      originalDisabled.set(slideshow, slideshow.getAttribute('disabled'));
      slideshow.setAttribute('disabled', 'false');

      const interval = setInterval(() => slideshow.next(), AUTOPLAY_INTERVAL);
      galleryIntervals.set(gallery, interval);
    }

    function stopAutoplay(gallery) {
      const interval = galleryIntervals.get(gallery);
      if (interval) {
        clearInterval(interval);
        galleryIntervals.delete(gallery);

        // Restore original disabled state
        const slideshow = gallery.querySelector('slideshow-component');
        if (slideshow) {
          const original = originalDisabled.get(slideshow);
          if (original === 'true') {
            slideshow.setAttribute('disabled', 'true');
          }
          originalDisabled.delete(slideshow);
        }
      }
    }

    function initGallery(gallery) {
      gallery.addEventListener('pointerenter', () => startAutoplay(gallery));
      gallery.addEventListener('pointerleave', () => stopAutoplay(gallery));

      // Stop autoplay when hovering swatch container to prevent image cycling
      const swatchContainer = gallery.querySelector('.product-card__image-swatches');
      if (swatchContainer) {
        swatchContainer.addEventListener('pointerenter', (e) => {
          e.stopPropagation();
          stopAutoplay(gallery);
        });
        swatchContainer.addEventListener('pointerleave', () => startAutoplay(gallery));
      }
    }

    document.querySelectorAll('.card-gallery').forEach(initGallery);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.classList?.contains('card-gallery')) initGallery(node);
            node.querySelectorAll?.('.card-gallery').forEach(initGallery);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
